export default "__VITE_ASSET__1c773a47__"